import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store';

const baseURL = process.env.VUE_APP_API_ENDPOINT;
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true

export const addToken = (token) => {
  axios.defaults.headers.common['authorization'] = 'Bearer ' + access_token;
}

let isRefreshing = false;
let failedQueue = []; // new queue system for refresh token

const processQueue = (error, token = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });
  failedQueue = [];
};

// REQUEST INTERCEPTOR
axios.interceptors.request.use(
  async (request) => {
    const isRefreshRequest =
      request.url.includes(
        '/authentication/refresh-token'
      );

    // Hold the new request until the refresh token
    if (isRefreshing && !isRefreshRequest) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (!isRefreshing) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
    }


    const token = store.state.user.token;
    if (token) {
      request.headers.authorization = `Bearer ${token}`;;
    }
    const actorEmail = store.state.user.user && store.state.user.user.email;
    if (actorEmail) {
      request.headers['x-actor-email'] = actorEmail;
    }
    return request;
  },
  error => {
    Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR
axios.interceptors.response.use(async (response) => {
  return response;
}, async (error) => {
  const originalRequest = error.config;
  let response = error.response;
  const isRefreshRequest = originalRequest.url.includes('/authentication/refresh-token');
  const errorMessages = ['jwt expired', 'Invalid old token', 'Sesion token expired'];
  const errorStatus = [500, 401, 403];


  // Decode response json error for arrayBuffer type requests
  if (originalRequest.responseType === 'arraybuffer') {
    let bufferJsonData = JSON.parse(new TextDecoder().decode(error.response.data))
    response.data = bufferJsonData
  }
  if (errorStatus.includes(response.status) && errorMessages.includes(response.data.error.message) && !isRefreshRequest && !originalRequest._retry ) {
    try {

      // Hold the new responses until the refresh token
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve,
            reject,
          });
        })
          .then((token) => {
            originalRequest.headers.authorization = `Bearer ${token}`;

            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
      const { email } = store.state.user.user;
      const user = { email: email }
      await store.dispatch('user/refreshToken', user) // refresh token
      processQueue(null, store.state.user.token); // process queued responses avoiding duplicate refresh token call or overwrite token
      originalRequest.headers.authorization = `Bearer ${store.state.user.token}`;
      return axios(originalRequest);
    } catch (error) {
      processQueue(error, null);
      return Promise.reject(error);
    } finally {
      isRefreshing = false;
    }
  }
  if (response.data.error.status === 500 && response.data.error.message.includes('duplicate key error')) {
    await store.commit('notification/show', {
      text: "Este email ya está registrado",
      color: "error"
    });
  }
  return Promise.reject(error);
});

Vue.use(VueAxios, axios);